import actions from "./actions";
import { call, put, takeLatest, fork } from "redux-saga/effects";
import {
  DELIVERY_INFO,
  GET_COMMUNES,
  GET_DISTRICTS,
  GET_PROVINCES,
} from "./constants";
import {
  spinApi, topupApi
} from "api/game";
import { deliveryInfoApi, getCommunesApi, getDistrictsApi, getProvincesApi } from "api/address";


export function* getProvincesSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(getProvincesApi, payload);
    yield put(actions.GET_PROVINCES.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_PROVINCES.failure(err));
  }
}

export function* getDistrictsSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(getDistrictsApi, payload);
    yield put(actions.GET_DISTRICTS.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_DISTRICTS.failure(err));
  }
}

export function* getCommunesSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(getCommunesApi, payload);
    yield put(actions.GET_COMMUNES.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_COMMUNES.failure(err));
  }
}

export function* deliveryInfoSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(deliveryInfoApi, payload);
    yield put(actions.DELIVERY_INFO.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.DELIVERY_INFO.failure(err));
  }
}

function* watchCommon() {
  yield takeLatest(GET_PROVINCES.request, getProvincesSaga);
  yield takeLatest(GET_DISTRICTS.request, getDistrictsSaga);
  yield takeLatest(GET_COMMUNES.request, getCommunesSaga);
  yield takeLatest(DELIVERY_INFO.request, deliveryInfoSaga);

}

export default function* rootChild() {
  yield fork(watchCommon);
}
